var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 10.1863 2.68629 7.5 6 7.5H42C45.3137 7.5 48 10.1863 48 13.5V34.5C48 37.8137 45.3137 40.5 42 40.5H6C2.68629 40.5 0 37.8137 0 34.5V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 8.5H6C3.23858 8.5 1 10.7386 1 13.5V34.5C1 37.2614 3.23858 39.5 6 39.5H42C44.7614 39.5 47 37.2614 47 34.5V13.5C47 10.7386 44.7614 8.5 42 8.5ZM6 7.5C2.68629 7.5 0 10.1863 0 13.5V34.5C0 37.8137 2.68629 40.5 6 40.5H42C45.3137 40.5 48 37.8137 48 34.5V13.5C48 10.1863 45.3137 7.5 42 7.5H6Z",
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8246 33.9999C31.3486 34.026 36.3907 29.542 36.3907 24.087C36.3907 18.1216 31.3486 13.9982 25.8246 14.0002H21.0705C15.4802 13.9982 10.8789 18.1228 10.8789 24.087C10.8789 29.5432 15.4802 34.0261 21.0705 33.9999H25.8246Z",
    fill: "#0079BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0925 14.8268C15.9843 14.8284 11.845 18.9256 11.8438 23.9823C11.845 29.0381 15.9843 33.1349 21.0925 33.1364C26.2019 33.1349 30.3421 29.0381 30.3428 23.9823C30.3421 18.9256 26.2019 14.8284 21.0925 14.8268ZM15.23 23.9823C15.2348 21.5113 16.7944 19.4042 18.9936 18.5669V29.3964C16.7944 28.5596 15.2347 26.4536 15.23 23.9823ZM23.1907 29.3988V18.5665C25.3907 19.4018 26.9526 21.5101 26.9566 23.9823C26.9526 26.4552 25.3907 28.5619 23.1907 29.3988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.77e81321195b86c01c290819e903e225.svg";
export { ForwardRef as ReactComponent };